import styled from 'styled-components';
import Colors from 'bit/mobiauto.web-ui-components.components.colors/colors';
import Button from 'bit/mobiauto.web-ui-components.components.button/Button';

export const FlexCenter = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: center;
  position: relative;
  padding: 16px;
  font-family: Poppins Regular;
`;

export const Main = styled.div`
  padding: 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  > svg {
    color: white;
  }
`;

export const MainContainer = styled.div`
  padding: 0px 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const UserId = styled.div`
  color: ${Colors.gray.medium};
`;

export const ChangePasswordButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.gray.medium};
  height: 1.75rem;
  cursor: pointer;

  svg {
    width: 14px;
    height: 14px;
    margin-right: 4px;
    fill: ${Colors.gray.medium};
  }
`;

export const SingOut = styled.div`
  pointer-events: auto;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${Colors.gray.medium};
  height: 1.75rem;
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0px 7px;
  align-items: center;
`;

export const ThemeButton = styled(Button)`
  color: ${({ theme }) =>
    `${theme.primary} !important` || `${Colors.primary.medium} !important`};
  border-color: ${({ theme }) =>
    `${theme.primary} !important` || `${Colors.primary.medium} !important`};
  font-size: 12px !important;
  border-radius: 2px !important;
  text-overflow: ellipsis !important;
  height: 24px !important;
  padding: 0 8px !important;
  font-family: 'Poppins Regular !important';
  text-transform: initial !important;
  width: 100% !important;
  margin-bottom: 8px !important;
  > span > svg {
    width: 15px;
    margin-right: 4px;
  }
`;

export const OvalBigger = styled.div`
  width: 40px;
  height: 40px;
  background-color: ${Colors.gray.nearWhite};
  font-family: Poppins Bold;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${Colors.gray.dark};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;
`;

export const styles = {
  rootItemisOpened: {
    width: '260px',
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)',
    backgroundColor: '#ffffff',
  },

  listItemisOpenedTop: {
    display: ' flex',
    position: 'relative',
    boxSizing: 'border-box',
    textAlign: 'left',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    padding: '0',
    height: '100px',
    fontFamily: 'Poppins Regular',
  },
  listItemisOpenedBottom: {
    display: 'flex',
    boxSizing: 'border-box',
    textAlign: 'left',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '4px 0',
    fontFamily: 'Poppins Regular',
  },

  nameisOpened: {
    fontSize: '14px',
    fontFamily: 'Poppins Regular',
    color: Colors.gray.dark,
    textTransform: 'capitalize',
    textOverflow: 'noWrap',
  },
  emailisOpened: {
    fontSize: '12px',
    color: Colors.gray.medium,
    textOverflow: 'ellipsis',
    textTransform: 'lowercase',
  },
  buttonisOpened: {
    fontSize: '10px',
    borderRadius: '2px',
    textOverflow: 'ellipsis',
    width: '68px',
    height: '24px',
    padding: '0 8px',
    fontFamily: 'Poppins Regular',
  },

  iconMargin: {
    marginRight: '0.8px',
    padding: '0px',
    display: 'flex',
    fontSize: '12px',
    minWidth: '0!important',
    flexDirection: 'column',
    fontFamily: 'Poppins Regular',
  },
  size: {
    fontSize: '10px',
    width: '68px',
    height: '24px',
    borderRadius: '2px',
  },

  avatar: {
    margin: 10,
    flexGrow: 3,
  },
  bigAvatar: {
    margin: 10,
    width: 60,
    height: 60,
    border: 0,
    objectFit: 'cover',
    borderRadius: 0,
  },
};
